const getNumericPriceAmount = (prices) => {
  if (!Array.isArray(prices)) {
    return null;
  }

  const matchingPrice = prices.find((price) =>
    Number.isFinite(Number(price?.amount))
  );

  return matchingPrice ? Number(matchingPrice.amount) : null;
};

export const getCheapestVariantDetails = (product) => {
  const variants = Array.isArray(product?.variants) ? product.variants : [];

  const cheapestVariant = variants.reduce((lowest, variant) => {
    const price = getNumericPriceAmount(variant?.prices);

    if (price === null) {
      return lowest;
    }

    if (!lowest || price < lowest.price) {
      return { variant, price };
    }

    return lowest;
  }, null);

  const fallbackVariant = variants.find(Boolean) || null;
  const resolvedVariant = cheapestVariant?.variant || fallbackVariant;
  const title =
    typeof resolvedVariant?.title === "string" ? resolvedVariant.title : "";

  return {
    variant: resolvedVariant,
    price: cheapestVariant?.price ?? null,
    title,
    hasPrice: cheapestVariant !== null,
  };
};
